import { Action, createReducer, on } from '@ngrx/store';
import * as AnnotationsActions from '../actions/annotations.actions';

export const annotationsFeatureKey = 'annotations';

export interface State {
  annotations: { [category: string]: { [id: string]: any } };
  loading: boolean;
  loaded: boolean;
  error: any;
}

export const initialState: State = {
  annotations: {},
  loading: false,
  loaded: false,
  error: null,
};

export const annotationsReducer = createReducer(
  initialState,

  on(AnnotationsActions.loadAnnotations, (state) => ({
    ...state,
    loading: true,
  })),

  on(AnnotationsActions.loadAnnotationsSuccess, (state, { annotations }) => ({
    ...state,
    annotations,
    loading: false,
    loaded: true,
    error: null,
  })),

  on(AnnotationsActions.loadAnnotationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: false,
    error,
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return annotationsReducer(state, action);
}
